import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Icons } from 'src/app/models/constants';
import { AuthService } from 'src/app/services/auth.service';
import { SystemUser } from 'src/app/models/systemUser.model';
@Component({
  selector: 'app-error',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FontAwesomeModule
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnInit {
  // Inject dependencies
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);
  public Icon = Icons;
  public errorReason = '';
  public code = signal(0);
  public user = signal<SystemUser | null>(null);

  ngOnInit(): void {
    // Get error parameters from route
    this.route.queryParams.subscribe(params => {
      this.errorReason = params['reason'] || 'unknown';
      this.code.set(params['code'] || 0);
      this.user.set(this.authService.b2cUser());
    });
  }

  /**
   * Retry login with MSAL
   */
  async retryLogin(): Promise<void> {
    try {
      // Use the MSAL service which is already initialized through app config
      this.authService.logout();
    } catch (error: unknown) {
      console.error('Login failed:', error);
      // If login fails, redirect to home to trigger proper auth flow
      window.location.href = '/';
    }
  }

  /**
   * Log the user out via MSAL redirect.
   * Shown for unauthorized errors.
   */
  logout(): void {
    this.authService.logout();
  }

  /**
   * Go back to previous page or home
   */
  goBack(): void {
    if (window.history.length > 0) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }

  /**
   * Navigate to home page
   */
  goHome(): void {
    window.location.href = '/';
  }
}
